export interface WicketOttEntitlement {
  concurrency_limit: string;
  content_reference: WicketOttContentreference;
  expiration_time: string;
  origin: {
    id: string;
    type: string;
  };
}

interface WicketOttContentreference {
  id: string;
  type: string;
}
